/*
 * Copyright 2026 Intuition Robotics ltd
 */
import * as React from "react";
import {useState} from "react";
import {DialogModule, ToastModule} from "@intuitionrobotics/thunderstorm/frontend";
import {DB_Patient} from "@app/app-shared/patient";
import {COLORS} from "@res/colors";
import {FONTS} from "@res/fonts";
import {ICONS} from "@res/icons"; // for cross_s
import {Spacing} from "@styles/styles";
import {CheckinModule} from "@modules/CheckinModule";

type Props = { patient: DB_Patient };

export const UpdateCheckInDialog: React.FC<Props> = ({patient}) => {
    const [pending, setPending] = useState(false);

    const onConfirm = () => {
        if (pending) return;
        setPending(true);
        CheckinModule.markCheckedIn(patient.unitId, ok => {
            if (ok) {
                ToastModule.toastInfo(`${patient.name} marked as checked in`);
                DialogModule.close();
                return;
            }
            // Error toast is raised inside CheckinModule. Re-enable the Confirm
            // button so the care manager can retry without reopening the dialog.
            setPending(false);
        });
    };

    return (
        <div style={{
            backgroundColor: COLORS.white, borderRadius: 8,
            width: 480, padding: Spacing.l
        }}>
            <div className={"ll_h_c"} style={{justifyContent: "space-between"}}>
                {FONTS.medium_21("Update Check-In", {color: COLORS.primary_blue})}
                <div className={"clickable"} onClick={() => DialogModule.close()}>
                    {ICONS.icon_cross_s(COLORS.neutral_gray_1, 16)}
                </div>
            </div>
            <div style={{height: 1, backgroundColor: COLORS.neutral_gray_1, margin: `${Spacing.m}px 0`}}/>
            {/* Single inline text flow — FONTS.* spans are display:inline-block,
                which collapses whitespace at element boundaries and makes the name
                visually butt against the surrounding words. */}
            <div style={{
                padding: `${Spacing.s}px 0 ${Spacing.l}px`,
                fontFamily: "Inter-Regular",
                fontSize: 16,
                color: COLORS.black
            }}>
                Mark <span style={{fontFamily: "Inter-Bold"}}>{patient.name}</span> as checked-in?
            </div>
            <div className={"ll_h_c"} style={{justifyContent: "flex-end", gap: Spacing.m, marginTop: Spacing.l}}>
                <div
                    className={"clickable"}
                    onClick={() => DialogModule.close()}
                    style={{
                        padding: `${Spacing.s}px ${Spacing.l}px`,
                        border: `1px solid ${COLORS.neutral_gray_1}`,
                        borderRadius: 4
                    }}
                >
                    {FONTS.reg_16_black("Cancel")}
                </div>
                <div
                    className={"clickable"}
                    onClick={pending ? undefined : onConfirm}
                    style={{
                        padding: `${Spacing.s}px ${Spacing.l}px`,
                        backgroundColor: COLORS.primary_blue,
                        color: COLORS.white,
                        borderRadius: 4,
                        opacity: pending ? 0.6 : 1
                    }}
                >
                    {FONTS.medium_16_white(pending ? "Saving..." : "Confirm")}
                </div>
            </div>
        </div>
    );
};
